export default __webpack_public_path__ + "static/media/limonwaves.633286bd.svg";